import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Heart, User, X, Sparkles } from "lucide-react";

const RegisterPrompt = ({ isOpen, onClose, onRegister }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
        style={{ zIndex: 2147483648 }}
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.9, opacity: 0, y: 20 }}
          className="bg-gradient-to-br from-white via-neutral-ivory to-accent-rose/20 rounded-3xl p-8 max-w-md w-full shadow-2xl border-2 border-accent-gold/30"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Botón cerrar */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 hover:bg-white/50 rounded-full transition-colors"
          >
            <X className="w-5 h-5 text-neutral-warm" />
          </button>

          {/* Icono decorativo */}
          <div className="flex justify-center mb-6">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
              className="relative"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-red-500 to-pink-500 rounded-full blur-2xl opacity-40"></div>
              <div className="relative p-5 bg-gradient-to-br from-red-500 to-pink-500 rounded-full shadow-elegant">
                <Heart className="w-12 h-12 text-white" fill="currentColor" />
              </div>
            </motion.div>
          </div>

          {/* Título */}
          <motion.h2
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="font-semibold text-3xl text-center mb-3"
            style={{
              color: "#d65ef5ff",
              fontFamily: "'Playfair Display', serif",
            }}
          >
            Tu opinión es muy importante
          </motion.h2>

          {/* Mensaje principal */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="font-sans text-neutral-warm text-center mb-2 leading-relaxed"
          >
            Nos encantaría conocer lo que piensas sobre esta foto.
          </motion.p>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="font-sans text-neutral-warm text-center mb-6 leading-relaxed"
          >
            Por favor,{" "}
            <span className="font-semibold" style={{ color: "#ec6fcdff" }}>
              regístrate con tu nombre
            </span>{" "}
            para poder compartir tu comentario y hacer de este momento algo aún
            más especial.
          </motion.p>

          {/* Decoración */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.6 }}
            className="flex items-center justify-center gap-2 mb-6"
          >
            <Sparkles className="w-4 h-4 text-accent-gold" />
            <div className="w-12 h-px bg-gradient-to-r from-transparent via-accent-gold to-transparent"></div>
            <Heart className="w-4 h-4 text-secondary" fill="currentColor" />
            <div className="w-12 h-px bg-gradient-to-r from-transparent via-accent-gold to-transparent"></div>
            <Sparkles className="w-4 h-4 text-accent-gold" />
          </motion.div>

          {/* Botones de acción */}
          <div className="space-y-3">
            <motion.button
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.7 }}
              onClick={onRegister}
              className="w-full py-4 text-white rounded-xl font-sans font-semibold shadow-elegant hover:shadow-elegant-hover transition-all flex items-center justify-center gap-2"
              style={{
                background:
                  "linear-gradient(135deg, #b43c4cff 0%, #b43c4cff 100%)",
              }}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <User className="w-5 h-5" />
              Registrarme ahora
            </motion.button>

            <motion.button
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.8 }}
              onClick={onClose}
              className="w-full py-3 text-neutral-warm font-sans font-medium transition-colors"
              style={{
                color: "#ec6fcdff",
              }}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              Tal vez más tarde
            </motion.button>
          </div>

          {/* Nota al pie */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.9 }}
            className="text-xs text-center text-neutral-warm/70 mt-6 font-sans"
          >
            Tu nombre será visible en los comentarios que hagas
          </motion.p>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default RegisterPrompt;
